<template lang="pug">
  div.MaintenanceAnnouncement
    div.bus
    div.content
      div.text 亲爱的用户：
      div.text 您好！
      div.text 非常抱歉的提示您，今晨由于产品维护升级，知微·危机案例库暂时无法访问，技术人员正在紧急修复中，给您带来的不便，敬请谅解。
      div.text 若您有其他产品相关意见建议，欢迎随时向我们反馈。我们会持续优化服务，给您提供更优质的体验~
</template>

<script>
export default {
  name: 'MaintenanceAnnouncement'
}
</script>

<style lang="scss" scoped>
.MaintenanceAnnouncement {
  .bus {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100000000000;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.3;
  }

  .content {
    padding: 5rem 5rem;
    width: 44rem;
    height: 25rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #2D3752;
    border-radius: 4px;
    color: #202020;
    z-index: 100000000000;

    .text {
      color: #fff;
      margin: 10px 0;

      &:nth-child(2) {
        text-indent: 20px;
      }

      &:nth-child(3) {
        text-indent: 20px;
      }

      &:nth-child(4) {
        text-indent: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/MaintenanceAnnouncement.vue